import { Injectable } from '@angular/core';

import { InitConstant } from '../Constant';

@Injectable({
    providedIn: 'root'
})
export class LogService
{
    private user_id = null;

    constructor(
    )
    {
    }

    debug(params)
    {
        if (InitConstant.IS_DEBUG) console.log(params);
    }

    table(params)
    {
        if (InitConstant.IS_DEBUG) console.table(params);
    }

    error(params)
    {
        console.error(params);
    }
}
